import { Container, Col, Row } from "reactstrap";
import * as BlogCollectionQL from "queries/blog-collection";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import BlogCollectionSchema from "@common/schema/blog-collection/public";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

export const LIST_FIELDS = {
  "/Public/BlogCollection": {
    fields: ["collectionId", "title", "updatedAt"],
  },
};

export const Sidebar = () => null;
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>
      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>
      <div className="mt-4"></div>
      <List
        path={"viewer.account.sites.get.blog.collections"}
        query={BlogCollectionQL.list}
        variables={{ siteId: params.siteId }}
        schema={BlogCollectionSchema}
        widgets={widgets}
        target={{ $ref: "/Public/BlogCollection" }}
        empty={"No collections yet."}
        config={LIST_FIELDS}
        content={({ item: { collectionId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${collectionId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
